import React, { Fragment, useCallback, useState } from 'react';
export const Match = (props) => {
    const [isFolded, fold] = useState(!!props.foldable);
    const { additionalBets, refund, cancel } = props.getInfo(props.id);
    const onclick = useCallback(() => {
        props.onClick && props.onClick(props.sportID, props.championshipID, props.id);
    }, [props.sportID, props.championshipID, props.id]);
    return <Fragment>
      <tr className={'g-tr'} onClick={props.foldable ? (() => { fold(!isFolded); }) : void 0}>
         <td className='g-d-date'>
            <div className='g-date'>{props.time}</div>
         </td>
         <td className='results-index-game-cmd g-d-players'>
            <div className='clearfix'>
               <b className={`g-d${props.onClick ? ' g-d-s' : ''}`} onClick={onclick}>
                  {`${props.toLocale(props.team1)}${props.toLocale(props.team2) ? ` - ${props.toLocale(props.team2)}` : ''}`}
               </b>
            </div>
         </td>
         <td className="g-d-score">
            {`${props.score || ''} ${cancel || ''}`}
            {!!props.foldable && <p className="dop-bets-count">
               {!!additionalBets && (`${isFolded ? '+' : '-'}${additionalBets.length}`)}
            </p>}
         </td>
      </tr>
      {!!additionalBets && (!!props.foldable && !isFolded || !props.foldable) && <tr className="g-a-tr">
         <td className="dopbets"></td>
         <td className="g-a-td" colSpan={19}>
            <div>
               <div className="g-a-l">
                  {additionalBets.map((bet) => <div key={bet}>{bet}</div>)}
               </div>
            </div>
         </td>
      </tr>}
      {!!refund && <tr className="g-a-tr">
         <td className="g-a-td" colSpan={20}>
            <div>
               <div className="g-a-l">
                  <div>{refund}</div>
               </div>
            </div>
         </td>
      </tr>}
   </Fragment>;
};



// WEBPACK FOOTER //
// ./src/web-frontend-components/results/live/tables/championship/Match.jsx